import { Callout, Heading, Section } from '@guess-the-rose/web-shared'
import { NextSeo } from 'next-seo'
import React from 'react'

import { GroupsList, Layout } from '../components'

export default function Page() {
  return (
    <Layout>
      <NextSeo title="Groups | Guess the Rose" />
      <Section noBottomPadding>
        <Heading as="h1" size="lg">
          Join a Group
        </Heading>
      </Section>
      <Section>
        <Callout>
          Looking to join an unlisted group that’s already been created? Have a
          friend share the invitation link with you!
        </Callout>
      </Section>
      <GroupsList />
    </Layout>
  )
}
